import { patternValidator } from './pattern.validator';
export const cardExpiryPatternValidator = patternValidator(/^(0[1-9]|1[0-2])\/([0-9]{2})$/);
//# sourceMappingURL=card-expiry-pattern.validator.js.map